module.exports = __webpack_public_path__ + "static/media/rewards_premium.29d72d24.png";